import Header from "./header";
import Title from "./title";
import Body from "./body";
import Root from "./root";
import Footer from "./footer";

export const Offcanvas = { Root, Header, Body, Title, Footer };
